export default __webpack_public_path__ + "static/media/video-place.fe409f82.png";